module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_3.002b38dd.png";